<template>
  <div class="out_container">

    <div class="header min_wrapper_1200">
			<div class="headerCon wrapper_1200 acea-row row-between-wrapper">
				<a href="javascript:void(0);" rel="sidebar" @click="AddFavorite()"><span
						class="iconfont icon-shoucang2"></span>收藏本站</a>
				<div class="user acea-row row-middle">
					<span   class="item acea-row row-middle"
						v-if="user.name " style="margin-right: 25px;">
						<!-- <div class="pictrue" v-if="user.name"><img :src="user.nama"></div> -->
						<p class="line1" style="max-width: 135px">{{ user.name }}</p>  <span @click="logout">[退出]</span>
					</span>
					<span v-if="!user.name"  v-rblink="{name:'login'}" class="item">登录/注册</span> 
					<span v-if="user.name" v-rblink="{name:'orderList'}" class="item">我的订单</span>  
					<span v-rblink="{name:'cart'}" class="cartNum" :class="'on'"><span
							class="iconfont icon-dingbu-gouwuche"></span>购物车</span>             
          <slot name="right"></slot>
				</div>
			</div>
		</div>

        <div data-v-a525b892="" class="nav min_wrapper_1200">

<div data-v-a525b892="" class="navCon wrapper_1200 acea-row row-between-wrapper">
	<div data-v-a525b892="" class="textPic acea-row row-middle">
		<div data-v-a525b892="" class="icon">
			<img data-v-a525b892="" src="~@/assets/images/login/jiafu-logo.png">
		</div>
		<div data-v-a525b892="" class="list">
			<a data-v-a525b892="" href="/" :class="$route.path=='/indexpc'? 'nuxt-link-exact-active nuxt-link-active font-color':''"  class="item" aria-current="page">首页</a>
			<a data-v-a525b892="" href="./goodslist" :class="$route.path=='/goodslist'? 'nuxt-link-exact-active nuxt-link-active font-color':''"  class="item">采购商城</a>
			<a data-v-a525b892="" href="./aboutus" :class="$route.path=='/aboutus'? 'nuxt-link-exact-active nuxt-link-active font-color':''"  class="item">关于我们</a>
			<a data-v-a525b892="" href="./BusinessForm" :class="$route.path=='/BusinessForm'? 'nuxt-link-exact-active nuxt-link-active font-color':''"  class="item">供应商入驻</a> 
		</div>
	</div>
	<div data-v-a525b892="" class="search acea-row row-between-wrapper">
		<div data-v-a525b892="" class="text acea-row row-middle">
			<span data-v-a525b892="" class="iconfont icon-xiazai5"></span>
			<input data-v-a525b892="" v-model="keywords" type="text" placeholder="搜索商品">
		</div>
		<div data-v-a525b892="" class="bnt bg-color" @click="search()">搜索</div>
	</div>
</div>

      </div>
  

    <div class="loginhead" v-show="false">
      <div class="headleft">
        <div class="logoAndname" @click="$router.push({ name: 'IndexPc' })">
          <img src="~@/assets/images/login/jiafu-logo.png" />
        </div>
        <div class="headnav">
          <a
            v-for="(item, index) in navArr"
            :key="index + 'a'"
            :class="item.class"
            @click="handleNavClick(item)"
            >{{ item.name }}</a
          >
        </div>
        <div class="headlefticon" v-if="user.id > 0">
          <div
            v-rblink="{ name: 'UpdataInfo' }"
            style="
              color: #fff;
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-left: 10px;
              font-size: 16px;
            "
            class="headlefticon_name"
          >
            {{ user.name }}
          </div>
          <div class="headicon">
            <div class="loginbtn registerbtn" @click="logout">退出</div>
          </div>
        </div>
        <div class="headlefticon" v-else>
          <div class="headicon">
            <div class="loginbtn" @click="loginOrRegisterClickFun(1)">登录11</div>
          </div>
          <div class="headicon">
            <div
              class="loginbtn registerbtn"
              @click="loginOrRegisterClickFun(2)"
            >
              注册
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
 
 <div>
    <div class="footer">
      <div class="wrapper_1200">
        <ul class="acea-row row-around row-middle">
          <li class="acea-row row-middle">
            <div class="picture">
              <span class="iconfont icon-pinzhong"></span>
            </div>
            <div>品种齐全，购物轻松</div>
          </li>
          <li class="acea-row row-middle">
            <div class="picture"><span class="iconfont icon-zhifa"></span></div>
            <div>多仓直发，极速配送</div>
          </li>
          <li class="acea-row row-middle">
            <div class="picture">
              <span class="iconfont icon-hanghuo"></span>
            </div>
            <div>正品行货，精致服务</div>
          </li>
          <li class="acea-row row-middle">
            <div class="picture"><span class="iconfont icon-dijia"></span></div>
            <div>天天低价，畅选无忧</div>
          </li>
        </ul> 
        <div class="recordNum">
          <div>
            <span>联系电话：18936019528</span
            ><span class="address"
              >地址：江苏省南京市江北新区星火路1号</span
            >
            <slot name="right"></slot>
          </div>
          <div class="record" >
            版权所有<a href="http://beian.miit.gov.cn/" target="_blank" class="num">
            苏ICP备05082904号-2</a>
          </div> 
        </div>
      </div>
    </div>
    <div class="floatWindow" v-if="false">
      <div class="list">
        <div class="item" @click="chatShow">
          <div class="iconfont icon-lianxikefu"></div>
          <div>联系客服</div>
        </div>
        <div class="item" @mouseleave="wxCodeHide">
          <div @mouseenter="wxCode">
            <div class="iconfont icon-weixin4"></div>
            <div>关注微信</div>
          </div>
          <div class="itemCon" v-if="iScode">
            <div class="ewm">
              <div class="pictrue">
                <div class="arrow"></div>
                <img :src="codeUrl" class="bicode" />
              </div>
              <div class="tip">扫码关注公众号</div>
            </div>
          </div>
        </div>
        <div class="item" @click="goCart">
          <div class="iconfont icon-cedaohang-gouwuche"></div>
          <div>购物车</div>
        </div>
        <div class="item" @click="goTop">
          <div class="iconfont icon-huidaodingbu1"></div>
          <div>回到顶部</div>
        </div>
      </div>
    </div> 
  </div>


  </div>
</template>
<script>
export default {
  name: "IndexLayout",
  data() {
    return {
      keywords:'',
      navArr: [
        { name: "首页", class: "nav_active", id: "113" },
        { name: "关于我们", class: "", id: "96" },
        { name: "新闻资讯", class: "", id: "97" },
        { name: "通知公告", class: "", id: "115" },
        { name: "开放课程", class: "", id: "course-20" },
        { name: "各类下载", class: "", id: "100" },
        { name: "相关查询", class: "", id: "146" },
      ],
      user: {
        id: 0,
        name: "",
      },
      booterNavArr: [
        { name: "法律声明", id: "137" },
        { name: "广告服务", id: "138" },
        // { name: "在线客服", id: "139" },
        // { name: "在线客服", id: "-4" },
        { name: "投诉建议", id: "140" },
        { name: "会员投稿", id: "-1" },
        // { name: "剧组动态", id: "-2" },
        { name: "超级用户入口", id: "-3" },
      ],
      codedescAndpic: {},
      // user: {
      //   id: 0,
      //   name: "",
      // },
      // popoverVisible: false,//el-popover
    };
  },
  created() {
    var _token = localStorage.getItem("_token");
    // console.log(_token);
    if (_token) {
      this.getUser();
    }
  },
  mounted() {
    //cate 映射下
    this.handleOrgan(); //处理关于我们
    this.handleDownloadPage(); //处理下载页
    this.handleCoursePageJump(); //处理 开放课程 页面
    //非cate映射
    this.handleFirstNavStyle(); //处理非cate 映射页面的 第一级nav样式问题

    //获取首页底部 二维码
    this.getCmsDetail(328);
  },
  watch: {
    $route: {
      handler() {
        this.handleFirstNavStyle(); //处理非cate 映射页面的 第一级nav样式问题
        // var _token = localStorage.getItem("_token");
        // if (_token && !this.user.id) {
        //   this.getUser();
        // }
        this.handleOrgan();
      },
      deep: true,
    },
  },
  methods: {
    search(){
      if(!this.keywords){
        return;
      }
      this.$router.push({name:'goodsList',query:{
        keywords:this.keywords
      }})
    },

			AddFavorite() {
				let url = window.location;
				let title = document.title;
				let ua = navigator.userAgent.toLowerCase();
				if (ua.indexOf("360se") > -1) {
					this.$message("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
				} else if (ua.indexOf("msie 8") > -1) {
					window.external.AddToFavoritesBar(url, title); //IE8
				} else if (document.all) {
					try {
						window.external.addFavorite(url, title);
					} catch (e) {
						this.$message("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
					}
				} else if (window.sidebar) {

					this.$message("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
				} else {
					this.$message("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
				}
			},
    //在线客服 点击事件
    // serviceCustomerClickFun(){
    //   var url = "https://hdysc1.qiyukf.com/client?k=2f609eb99cc5829d6e3bef06f6d198f6&wp=1&shuntId=0";
    //   var tmp = window.open(url, "_blank", "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes");
    //   tmp.moveTo(200,100);//指定窗口开始位置（左上角）
    //   tmp.resizeTo(1028, 720);//指定窗口结束位置（右下角）
    // },
    //获取文章详情
    getCmsDetail(id) {
      this.$api.get(
        "api/cms/detail",
        { id: id },
        (res) => {
          var codeDetail = res.data.data.extra_data;
          if (codeDetail && codeDetail.length > 0) {
            codeDetail.some((item) => {
              this.codedescAndpic[`${item.field_key}`] = item.value;
            });
          }
          var codedetail = this.codedescAndpic;
          this.codedescAndpic = {};
          this.codedescAndpic = codedetail;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getUser() {
      let that = this;
      that.$api.post(
        "/api/index/userdata",
        {},
        (r) => {
          that.user = r.data;
        },
        (r) => {
          // that.$message.error(r.msg);
        }
      );
    },
    logout() {
      let that = this;
      this.$confirm("确定退出吗？")
        .then((_) => {
          that.$api.post("/api/index/logout", {}, (r) => {
            localStorage.removeItem("_token");
            that.$router.push({ name: "Login" });
            this.user.id = 0;
          });
        })
        .catch((_) => {});
    },
    //登录 注册点击事件
    loginOrRegisterClickFun(key) {
      //key==1登录   /2 注册
      this.$router.push({ path: "/login" });
    },
    //booter  Nav  点击事件
    booterNavClickFun(val) {
      // console.log(val)
      if (val.id > 0) {
        this.$router.push({ path: "/cate", query: { id: val.id } });
      } else {
        if (val.id == -3) {
          this.$router.push({ path: "login" });
        }
      }
    },
    //处理非cate 映射页面的 第一级nav样式问题
    handleFirstNavStyle() {
      //处理首页
      if (this.$route.name == "IndexPc") {
        this.handleCourseContentStyle("首页");
        return;
      }
      // var urlLocation = window.location.href.split("?")[0].split("/");
      // if (urlLocation[urlLocation.length - 1] == "cate") {
      //   this.handleNavSty();
      // }
      if (this.$route.name == "Cate") {
        //处理cate 散射页面
        this.handleNavSty();
        return;
      }
      //处理课程详情页面
      if (
        this.$route.path == "/coursecontent" ||
        this.$route.path == "/worksdetail"
      ) {
        this.handleCourseContentStyle("开放课程");
        return;
      }
      //处理通知公告 或者新闻资讯
      if (this.$route.path == "/cmsdetail") {
        if (!this.$route.query.id) {
          return;
        }
        this.$api.get(
          "/api/cms/detail",
          { id: this.$route.query.id },
          (res) => {
            res.data.data.cate_ids.some((item) => {
              if (item == 115) {
                if (this.navArr[3].class != "") {
                  return;
                }
                this.navArr.some((item) => {
                  if (item.class != "") {
                    item.class = "";
                  }
                });
                this.navArr[3].class = "nav_active";
              }
            });
          },
          (err) => {
            console.log(err);
          }
        );
      }
      // if ("coursecontent" == urlLocation[urlLocation.length - 1]) {
      //   this.handleCourseContentStyle();
      // }
    },
    //处理下载页面内容区域
    handleDownloadPage() {
      if (this.$route.name != "Cate") {
        return;
      }
      if (
        parseInt(this.$route.query.id) >= 100 &&
        parseInt(this.$route.query.id) <= 104
      ) {
        this.$router.push({
          path: "/cate",
          query: { id: 100, idDown: this.$route.query.id },
        });
      }
    },
    //处理关于我们页面跳转的方法
    handleOrgan() {
      var organArr = [94, 95, 96, 107, 108, 109, 110, 111, 162];
      if (
        organArr.includes(parseInt(this.$route.query.id)) &&
        this.$route.name == "Cate"
      ) {
        // this.$router.push({
        //   path: "/cate",
        //   query: { id: parseInt(this.$route.query.id) },
        // });
        if (this.navArr[1].class != "") {
          return;
        }
        this.navArr.some((item) => {
          if (item.class != "") {
            item.class = "";
          }
        });
        this.navArr[1].class = "nav_active";
      }
    },
    handleNavSty() {
      var that = this;
      var result = this.navArr.some(function (item) {
        if (item.id == that.$route.query.id) {
          return true;
        }
      });
      for (var i = 0; i < this.navArr.length && result; i++) {
        if (
          this.navArr[i].class == "nav_active" &&
          this.navArr[i].id != this.$route.query.id
        ) {
          this.navArr[i].class = "";
        }
        if (
          this.navArr[i].id == this.$route.query.id &&
          this.navArr[i].class != "nav_active"
        ) {
          this.navArr[i].class = "nav_active";
        }
      }
      //处理特殊的course-9 等跳转
      if (!result) {
        this.handleCoursePageJump();
      }
    },
    //处理特殊的course页面跳转
    handleCoursePageJump() {
      if (!this.$route.query.id) {
        return;
      }
      if (this.$route.query.id.toString().indexOf("course") > -1) {
        this.navArr.some((item) => {
          if (item.id.toString().indexOf("course") > -1) {
            this.handleNavClickForCourse(item);
            return;
          }
        });
      }
    },
    //处理一级nav点击事件
    handleNavClick(val) {
      this.handleFirstNav(val);
      this.$router.push({ path: "/cate", query: { id: val.id } });
    },
    //处理一级nav样式问题
    handleFirstNav(val) {
      var targetnav = this.navArr.indexOf(val);
      for (var i = 0; i < this.navArr.length; i++) {
        if (this.navArr[i].class == "nav_active") {
          this.navArr[i].class = "";
        }
      }
      this.navArr[targetnav].class = "nav_active";
    },
    //特殊  处理课程系列的函数
    handleNavClickForCourse(val) {
      var targetnav = this.navArr.indexOf(val);
      for (var i = 0; i < this.navArr.length; i++) {
        if (this.navArr[i].class == "nav_active") {
          this.navArr[i].class = "";
        }
      }
      this.navArr[targetnav].class = "nav_active";
      // this.$router.push({ path: "/cate", query: { id: this.$route.query. } });
    },
    //特殊  处理课程详情course-content页面
    handleCourseContentStyle(jumpName) {
      var that = this;
      this.navArr.some((item) => {
        if (item.name == jumpName) {
          that.handleFirstNav(item);
          return;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.loginhead {
  height: 100px;
  background: #1981ff;
  display: flex;
  align-items: center;
  .headleft {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 1240px;
    margin: 0 auto;
    .logoAndname {
      display: flex;
      align-items: center;
      max-width: 210px;
      // height: 40px;
      max-height: 100px;
      // background-size: cover;
      // -webkit-background-size: cover;
      img {
        width: 160px;
        object-fit: cover;
      }
    }
    .headnav {
      height: 100px;
      line-height: 100px;
      overflow: hidden;
      a {
        font-size: 18px;
        font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
          "\5FAE\8F6F\96C5\9ED1";
        font-weight: 400;
        color: #ffffff;
        margin-right: 24px;
        cursor: default;
        &:hover {
          font-weight: bold;
          cursor: pointer;
        }
      }
      .nav_active {
        border-bottom: 2px solid #ffffff;
      }
    }
    .headlefticon {
      display: flex;
      flex-direction: row;
      // width: 138px;
      height: 36px;
      //   margin-left: 80px;
      margin-left: 0 !important;
      .headlefticon_name {
        &:hover {
          cursor: pointer;
        }
      }
      .headicon {
        display: flex;
        flex-direction: row;
        align-items: center;
        &:last-child {
          margin-left: 10px;
        }
        .loginbtn {
          background: #4e81df;
          text-align: center;
          height: 36px;
          width: 64px;
          line-height: 32px;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
          border-radius: 19px;
          border: 2px solid #ffffff;
          font-size: 16px;

          font-weight: 400;
          color: #ffffff;
          box-sizing: border-box;
          &:hover {
            cursor: pointer;
            opacity: 0.8;
            font-weight: bold;
          }
        }
        .registerbtn {
          background: #d22c46;
        }
      }
    }
  }
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
}
.booter {
  height: 346px;
  background: #e5eeff;
  position: relative;
  z-index: 1;
  overflow: hidden;
  .booter_line_up {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0 17px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #4a90e2;
    .booter_line_up_left {
      padding-top: 36px;
      box-sizing: border-box;
      margin: 0 0 7px 0;
      .booter_line_up_left_name {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        .booter_line_up_left_name_china {
          width: 248px;
          width: 120px;
          // height: 36px;
          height: 60px;
          background: url("~@/assets/images/listitem/logo_bottom.png") no-repeat
            center center;
          background-size: auto 100%;
        }
        .booter_line_up_left_name_ein {
          width: 118px;
          height: 12px;
          margin-left: 3px;
          background: url("~@/assets/images/listitem/www.eaechina.net.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .booter_line_up_left_sponsor {
        font-size: 14px;
        color: #666666;
        display: flex;
        flex-direction: row;
        margin: 32px 0 0 0;
        box-sizing: border-box;
        .booter_line_up_left_sponsor_left {
          margin-right: 23px;
        }
      }
      .booter_line_up_left_link {
        margin: 32px 0 0 0;
        ul {
          display: flex;
          flex-direction: row;
          li {
            margin: 0 17px 0 0;
            color: #1981ff;
            cursor: default;
            &:hover {
              font-weight: bold;
              cursor: pointer;
            }
          }
          a {
            color: #1981ff;
          }
        }
      }
    }
    .booter_line_up_right {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      .code_item {
        display: flex;
        flex-direction: column;
        &:first-child {
          margin: 0 21px 0 0;
        }
        .code_item_pic {
          width: 108px;
          height: 108px;
          object-fit: cover;
        }
        .code_item_font {
          text-align: center;
          margin: 8px 0 0 0;
          color: #1981ff;
        }
      }
    }
  }
  .booter_line_down {
    display: flex;
    flex-direction: column;
    align-items: center;
    .friends_link {
      color: #666666;
      font-size: 14px;
      margin: 24px 0 0 0;
      ul {
        display: flex;
        flex-direction: row;
        color: #666666;
        li:not(:first-child) {
          &:hover {
            font-weight: bold;
            cursor: default;
          }
        }
      }
    }
    .copyright_up {
      font-size: 12px;
      color: #9b9b9b;
      margin: 8px 0;
    }
    .copyright_down {
      font-size: 12px;
      color: #9b9b9b;
    }
  }
  .heart_pic {
    width: 422px;
    height: 291px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
}
</style>


<style scoped lang="scss">
	.header {
		width: 100%;
		height: 40px;
		background-color: #282828;
		font-size: 12px;
		color: #B4B4B4;
		cursor: pointer;

		.headerCon {
			height: 100%;

			a {
				color: #B4B4B4;

				&:hover {
					color: #fff;
				}
			}

			.icon-shoucang2 {
				margin-right: 5px;
			}

			.user {
				.item {
					margin-right: 8px;
					position: relative;
					padding-left: 8px;
					color: #B4B4B4;

					&:hover {
						color: #fff;
					}

					&~.item:before {
						position: absolute;
						content: ' ';
						width: 1px;
						height: 14px;
						background-color: rgba(255, 255, 255, 0.11);
						left: 0;
						top: 50%;
						margin-top: -7px;
					}

					.pictrue {
						width: 22px;
						height: 22px;
						border-radius: 50%;
						margin-right: 8px;

						img {
							width: 100%;
							height: 100%;
							border-radius: 50%;
						}
					}

					.king {
						width: 13px;
						height: 12px;
						display: block;
						margin-left: 6px;
						margin-top: -5px;
					}
				}

				.cartNum {
					width: 118px;
					height: 40px;
					background: #3C3C3C;
					text-align: center;
					line-height: 40px;
					color: #b4b4b4;
					margin-left: 10px;

					&:hover {
						color: #fff;
					}

					&.on {
						background: #0175c0;
						color: #fff;
						opacity: 0.75;

						&:hover {
							opacity: 1;
						}
					}

					.iconfont {
						margin-right: 7px;
					}
				}
			}
		}
	}

	.nav {
		width: 100%;
		height: 96px;
		background: #FFFFFF;

		.navCon {
			height: 100%;

			.textPic {
				height: 100%;

				.icon {
					cursor: pointer;
					width: 140px;
					height: 60px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.list {
					margin-left: 85px;

					.item {
						padding: 15px 10px;
						margin-right: 13px;
						color: #282828;
						font-size: 16px;
						font-weight: 400;
						cursor: pointer;

						&:hover {
							color: #0175c0;
						}
					}

				}
			}

			.search {
				width: 360px;
				height: 40px;
				border: 1px solid #0175c0;
				border-radius: 2px;
				cursor: pointer;

				.text {
					width: 290px;
					padding-left: 14px;
					color: #C1C1C1;

					input {
						width: 250px;
						height: 36px;
						border: none;
						outline: none;
						padding-left: 10px;
						margin-top: -2px;
					}

					.iconfont {
						font-size: 15px;
						margin-right: 5px;
					}
				}

				.bnt {
					width: 64px;
					height: 40px;
					text-align: center;
					line-height: 40px;
					color: #fff;
				}
			}
		}
	}
	.icon-duoshanghupc-daohuotongzhi {
	  font-size: 14px;
	  color: #fff;
	  padding: 0 5px 0 2px;
	  animation: shock 3s infinite ease;
	}
	@keyframes shock {
	  5%,
	  25%,
	  45% {
	    transform: rotate(8deg);
	  }
	  0%,
	  10%,
	  30%,
	  50% {
	    transform: rotate(-8deg);
	  }
	  15%,
	  35%,
	  55% {
	    transform: rotate(4deg);
	  }
	  20%,
	  40%,
	  60% {
	    transform: rotate(-4deg);
	  }
	  65%,
	  100% {
	    transform: rotate(0deg);
	  }
	}
	.service_num {
	  position: absolute;
	  transform: scale(0.7);
	  top: -6px;
	  left: 14px;
	  font-size: 10px;
	  background-color: #fff;
	  border-radius: 10px;
	  padding: 0 3px;
	  color: rgb(201, 18, 18);
	}
	.service_color:hover {
	  color: #000 !important;
	}

  .footer {
  // margin-top: 50px;
  background-color: #f2f2f2;
  .wrapper_1200 {
    background-color: #f2f2f2;
  }
  ul {
    height: 104px;
    border-bottom: 1px solid #e2e2e2;
    li {
      .picture {
        width: 40px;
        height: 40px;
        border: 1px solid #707070;
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        margin-right: 14px;
        .iconfont {
          font-size: 23px;
          color: #707070;
        }
      }
    }
  }
  .link_list{
    height:46px;
    border-bottom: 1px solid #e2e2e2;
    span{
      display: inline-block;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .recordNum {
    text-align: center;
    padding: 30px 0 48px 0;
    .address {
      margin-left: 40px;
    }
    .record {
      margin-top: 6px;
      .num {
        margin-left: 10px;
        color: #282828;
        &:hover {
          color: #0175c0;
        }
      }
    }
  }
}

.floatWindow {
  position: fixed;
  right: 0;
  bottom: 15%;
  width: 70px;
  z-index: 99;
  cursor: pointer;
  background-color: #fff;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);

  .list {
    .item {
      position: relative;
      width: 100%;
      height: 74px;
      text-align: center;
      font-size: 12px;
      color: #5c5c5c;
      padding: 12px 0;
      &:hover {
        color: #0175c0;
      }
      .iconfont {
        margin-bottom: 5px;
        font-size: 25px;
      }
      & ~ .item {
        &:before {
          position: absolute;
          content: " ";
          width: 48px;
          height: 1px;
          background-color: #f0f0f0;
          top: 0;
          left: 50%;
          margin-left: -24px;
        }
      }
      .itemCon {
        right: 100%;
        position: absolute;
        top: 0;
        padding-right: 20px;
        .ewm {
          width: 140px;
          border: 1px solid #eeeeee;
          background-color: #fff;
          padding: 8px 6px;
          .tip {
            font-size: 14px;
            color: #666;
            margin-top: 6px;
          }
          .pictrue {
            width: 126px;
            height: 126px;
            vertical-align: middle;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .arrow {
              position: absolute;
              right: -16px;
              top: 10px;
              width: 0px;
              height: 0px;
              border: 8px solid transparent;
              border-left-color: #eee;
              &:before {
                position: absolute;
                left: -8px;
                top: -7px;
                content: "";
                width: 0px;
                height: 0px;
                border: 7px solid transparent;
                border-left-color: #fff;
              }
            }
          }
        }
      }
    }
  }
}


	.nav {
		width: 100%;
		height: 96px;
		background: #FFFFFF;

		.navCon {
			height: 100%;

			.textPic {
				height: 100%;

				.icon {
					cursor: pointer;
					width: 140px;
					height: 60px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.list {
					margin-left: 85px;

					.item {
						padding: 15px 10px;
						margin-right: 13px;
						color: #282828;
						font-size: 16px;
						font-weight: 400;
						cursor: pointer;

						&:hover {
							color: #0175c0;
						}
					}

				}
			}

			.search {
				width: 371px;
				height: 40px;
				border: 1px solid #0175c0;
				border-radius: 2px;
				cursor: pointer;

				.text {
					width: 290px;
					padding-left: 14px;
					color: #C1C1C1;

					input {
						width: 250px;
						height: 36px;
						border: none;
						outline: none;
						padding-left: 10px;
						margin-top: -2px;
					}

					.iconfont {
						font-size: 15px;
						margin-right: 5px;
					}
				}

				.bnt {
					width: 64px;
					height: 40px;
					text-align: center;
					line-height: 40px;
					color: #fff;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// IndexLayout.vue?6cf4fd6e